// extracted by mini-css-extract-plugin
module.exports = {"Spinner":"LoadingSpinnerWrapper_Spinner__J7pYf","SpinnerVisible":"LoadingSpinnerWrapper_SpinnerVisible__1LAfn"};